import React, { FC } from 'react'
import NextError, { ErrorProps } from 'next/error'

import { GetStaticProps } from '../redux/types'
import { getLanguageFromLocale, getMessagesFromLanguage } from '../i18n/utils'
import { getDomainFromLanguage } from '@common/utils/request-utils'
import { PageProps } from '@src/types'

type Props = {
    title?: string
} & PageProps

export const getStaticProps: GetStaticProps<Props> = async ({ locale }) => {
    const language = getLanguageFromLocale(locale)
    const domain = getDomainFromLanguage(language)
    return {
        props: {
            requestUserConfig: { domain, language },
            messages: await getMessagesFromLanguage(language),
        },
    }
}

const Error: FC<ErrorProps> = props => <NextError {...props} />

export default Error
